import { Route } from 'react-router-dom';
import ProtectedRoute from 'shared/routes/Protected-Route';
import LegacyTenantPathRedirect from 'shared/routes/LegacyTenantPathRedirect';
import PayrollPage from './pages/PayrollPage';

/** Payroll (111) — /{tenantName}/payroll */
export const payrollRoutes = (
  <>
    <Route path="/:tenantKey/payroll" element={<ProtectedRoute element={<PayrollPage />} />} />
    <Route path="/payroll" element={<LegacyTenantPathRedirect />} />
  </>
);

export default payrollRoutes;
